import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const Blah = styled.div`
    width: 350px;
    height: 150px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1 {
        text-transform: uppercase;
    }
`

const Jumbotron = ({title, subtext}) => {
    return (
        <div className="jumbotron jumbotron-fluid d-flex justify-content-center">
            <Blah className="text-center">
                <h1 className="display-5">{title}</h1>
                <Helmet title={title} />
                <p className="lead">{subtext}</p>
            </Blah>
        </div>
    )
}

export default Jumbotron;


// WEBPACK FOOTER //
// ./src/components/Jumbotron.js